import postsFilter from "./posts-filters";

window.addEventListener('slate_init', function () {
    postsFilter();
});
